import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/Portal";

import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import BookOnline from "@/pages/public/BookOnline";
import WaitingList from "@/pages/public/WaitingList";
import Contact from "@/pages/public/Contact";
import Terms from "@/pages/public/Terms";
import Membership from "@/pages/public/Membership";
import MembershipReturn from "@/pages/public/MembershipReturn";
import Auth from "@/pages/Auth";
import BookingReturn from "@/pages/BookingReturn";
import MemberPortal from "@/pages/member/MemberPortal";
import AdminPortal from "@/pages/admin/AdminPortal";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/book-online" element={<BookOnline />} />
            <Route path="/waiting-list" element={<WaitingList />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/membership/return" element={<MembershipReturn />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/booking/return" element={<BookingReturn />} />
            <Route path="/portal/members" element={<ProtectedRoute role="parent"><MemberPortal /></ProtectedRoute>} />
            <Route path="/portal/admin" element={<ProtectedRoute role={["admin", "staff"]}><AdminPortal /></ProtectedRoute>} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
